import { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import { formatIsoDateString, secondsToDhms } from "../../utils/helpers";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";

// ES Modules import

const BotpressAssessmentDialog = props => {
  const {
    open,
    assessmentRecord,
    onClose,
    onAccept,
    onDelete,
    dialogTitle = "Edit Assessment",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "sm",
    fullWidth = true,
    deleteMessage = "Delete",
  } = props;

  const theme = useTheme();

  const [editedAssessmentRecord] = useState(assessmentRecord);

  //input
  const calculateDate = dateString => {
    const isoString = formatIsoDateString(dateString).split(",");
    const date = new Date(dateString); // Parses the ISO string into a Date object
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Ensures 12-hour format with AM/PM
    };
    return isoString[0] + ", " + date.toLocaleTimeString("en-US", options);
  };
  const [comment, setComment] = useState(assessmentRecord.comment);
  const [date] = useState(calculateDate(assessmentRecord.createdAt));
  const [userName, setUserName] = useState(assessmentRecord.userName);
  const [archived, setArchived] = useState(assessmentRecord.archived);

  const [showConfirm, setShowConfirm] = useState(false);

  const onDeleteHandler = () => {
    onDelete(editedAssessmentRecord);
  };

  const onAcceptHandler = () => {
    try {
      editedAssessmentRecord.comment = comment;

      //TODO check to see other stuff needs updating
      onAccept(editedAssessmentRecord);
    } catch (error) {
      console.log(error);
    }
  };

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid spacing={1} container size={{ xs: 12 }}>
          <Grid item size={{ xs: 12 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Assessment Name"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              value={assessmentRecord.assessmentName}
              disabled={true}
            />
          </Grid>

          <Grid item container size={{ xs: 4 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Run On"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              value={date}
              disabled={true}
            />
          </Grid>

          <Grid item container size={{ xs: 6 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Execution Time"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              value={secondsToDhms(assessmentRecord.elapsedSeconds)}
              disabled={true}
            />
          </Grid>

          <Grid item container size={{ xs: 2 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Questions"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              value={assessmentRecord.questionCount}
              disabled={true}
            />
          </Grid>

          <Grid item container size={{ xs: 12 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Comment"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              rowCount={5}
              multiline={true}
              value={comment}
              onChange={event => setComment(event.target.value)}
            />
          </Grid>

          <Grid item container size={{ xs: 8 }}>
            <OmniTextField
              sx={{ width: "100%", marginTop: "10px" }}
              label={"Assessment Run By"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              rowCount={7}
              multiline={false}
              value={userName}
              onChange={event => setUserName(event.target.value)}
            />
          </Grid>

          <Grid item container size={{ xs: 4 }}>
            <Box
              sx={{
                display: editedAssessmentRecord.id == null ? "none" : "flex",
                width: "100%",
                flexDirection: "row",
                marginTop: "10px",
                marginLeft: "24px",
                justifyContent: "left",
              }}
            >
              <Switch
                checked={archived}
                onChange={() => {
                  setArchived(val => !val);
                }}
              />
              <Typography variant="body2" sx={{ marginTop: "8px" }}>
                Archived
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            paddingRight: theme.spacing(2),
            paddingBottom: 0,
            display: "flex",
            flexDirection: "row",
            userSelect: "none",
            webkitUserSelect: "none",
            position: "relative",
            flexGrow: 1,
          }}
        >
          {assessmentRecord.id != null && props.onDelete != null && (
            <OmniResponsiveButton
              icon={<DeleteIcon />}
              onClick={() => setShowConfirm(true)}
              buttonText={deleteMessage}
              tooltipTitle=""
            />
          )}
        </Box>
        <Box
          sx={{
            flexGrow: 0,
            flexShrink: 1,
          }}
        >
          {cancelMessage && (
            <Button
              onClick={onCloseHandler}
              color="secondary"
              variant="contained"
              sx={{ marginRight: theme.spacing(2) }}
            >
              {cancelMessage}
            </Button>
          )}
          <Button onClick={onAcceptHandler} color="secondary" variant="contained">
            {okMessage}
          </Button>
        </Box>
      </DialogActions>

      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want delete this Entry?"}
          onAccept={() => {
            setShowConfirm(false);
            onDeleteHandler();
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default BotpressAssessmentDialog;
